// extracted by mini-css-extract-plugin
export default {"main":"Slideopen_main__J1DD7","icons1":"Slideopen_icons1__De2s7","iconsbox":"Slideopen_iconsbox__0Xqsm","navlink":"Slideopen_navlink__APBZt"};